import { BaseEntity } from 'src/app/entities/base-entity/base-entity';
import { Tag } from 'src/app/entities/tag/tag';
import { Project } from 'src/app/entities/project/project';
import { DateTime } from '../value-objects/date-time/date-time';
import { User } from '../user/user';

export interface TrackPermissions {
  delete: boolean;
  update: boolean;
}

/**
 * Class representing a time-track in the tracking system.
 *
 * @class TimeTrack
 */
export class TimeTrack extends BaseEntity {
  /**
   * Creates an instance of TimeTrack.
   */
  constructor(
    _uuid: string,
    protected _title: string,
    protected _from: Date,
    protected _to: Date | null,
    protected _permissions: TrackPermissions,
    protected _project: Project | undefined,
    protected _author?: User | null,
    protected _tags: Tag[] = [],
    protected _time_spent?: number,
  ) {
    super(_uuid);
  }

  get title(): string {
    return this._title;
  }

  get from(): Date {
    return this._from;
  }

  get to(): Date | null {
    return this._to;
  }

  get permissions(): TrackPermissions {
    return this._permissions;
  }

  get time_spent(): number | undefined {
    return this._time_spent;
  }

  get project(): Project | undefined {
    return this._project;
  }

  get author(): User | null {
    return this._author || null;
  }

  get tags(): Tag[] {
    return this._tags;
  }

  isOngoing(): boolean {
    return this._to === null;
  }

  /**
   * Creates a TimeTrack entity from different types.
   *
   * Takes care of converting the value to a DateTime object.
   *
   * @param value
   * @returns {DateTime}
   */
  protected static _valueToTimeDate(
    value: DateTime | Date | string | null | undefined
  ): DateTime {
    if (value instanceof DateTime) {
      return value;
    }

    return DateTime.create(value);
  }
}
